import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.less';
import classNames from 'classnames';
import { areEqualIgnoreCase, getPathTitle, imgUrl } from '@/shared/utils';
import { useConfigProvider } from '@/context/ConfigProvider';
import { Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { ActionType, ProList } from '@ant-design/pro-components';
import { useRouter } from 'next/router';
import _ from 'lodash';
import { getArticleListSearchData } from '@/lib/service';
import { HomeArticleModel } from '@/types/home';
import EmptyPage from '../Common/Empty';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

const SearchContent = () => {
  // const { isMobile } = useConfigProvider();
  const actionRef = useRef<ActionType>();
  const router = useRouter();
  const { value, tag } = router.query;
  const [searchText, setSearchText] = useState<string | undefined>();
  const [sortText, setSortText] = useState('clickNum');
  const [showEmpty, setShowEmpty] = useState<boolean>(false);
  const { t } = useTranslation();

  const tagRequest = tag != undefined;

  useEffect(() => {
    if (actionRef.current) {
      actionRef.current.reload();
    }
  }, [searchText, sortText]);

  useEffect(() => {
    if (tagRequest) {
      actionRef.current.pageInfo.current = 1;
      setSearchText(`${tag}`);
    }
  }, [tag]);

  useEffect(() => {
    if (!tagRequest) {
      actionRef.current.pageInfo.current = 1;
      setSearchText(`${value}`);
    }
  }, [value]);

  const onChange = (value: string) => {
    if (value == sortText) {
      return;
    }
    setSortText(value);
  };

  return (
    <div className={classNames(styles.popularProductsContainer, '')}>
      <div className={styles.homeContent}>
        <div className={styles.titleContainer}>
          <h3 className={styles.title}>
            {tagRequest ? (
              tag
            ) : (
              <>
                <SearchOutlined /> {`${t('search')}: ${value}`}
              </>
            )}
          </h3>
        </div>

        {!tagRequest && (
          <div className={styles.searchContainer}>
            <Select
              style={{ minWidth: 182 }}
              defaultValue={sortText}
              optionFilterProp="children"
              onChange={onChange}
              options={[
                {
                  value: 'clickNum',
                  label: `${t('popularHighToLow')}`,
                },
                {
                  value: 'insertTime',
                  label: `${t('dateNewestToOldest')}`,
                },
              ]}
            />
          </div>
        )}

        <div className={styles.rowListContainer}>
          <ProList<any>
            className={styles.proListContainer}
            actionRef={actionRef}
            ghost={true}
            pagination={{
              defaultPageSize: 12,
              showSizeChanger: false,
              align: 'center',
              showTotal: null,
              // style: {
              //   color: "red"
              // }
            }}
            showActions="hover"
            onItem={(record: HomeArticleModel) => {
              return {
                onClick: () => {
                  if (record?.article_id != undefined) {
                    // router.push(`/article/${record?.article_id}`);
                    router.push(`/article/${record?.article_id}/${getPathTitle(record?.title)}`);
                  }
                },
              };
            }}
            itemCardProps={{
              bodyStyle: {
                margin: 0,
                padding: 0,
              },
            }}
            metas={{
              title: {
                render: (_, reacd: HomeArticleModel) => {
                  return (
                    <div className={styles.contentItem}>
                      {/* <img src={imgUrl(reacd?.cover_image, "mid")}
                        alt="logo"
                        className={styles.imgItem}
                        style={{ aspectRatio: isMobile ? "1" : "16/9" }}
                        loading="lazy"
                      /> */}

                      {reacd?.cover_image &&
                        <div className={styles.imgItemContainer}>
                          <Image
                            className={styles.imgItem}
                            src={imgUrl(reacd?.cover_image, 'mid')}
                            alt={reacd?.title}
                            loading="lazy"
                            width={263}
                            height={148}
                            layout="responsive"
                          />
                        </div>
                      }

                      {/* <div className={styles.imgContainer}>
                        <Image className={styles.image}
                          src={imgUrl(reacd?.cover_image, "mid")}
                          alt={reacd?.title}
                          loading="lazy"
                          style={{ aspectRatio: isMobile ? "1" : "16/9" }}
                          objectFit="cover"
                          layout="fill"
                        />
                      </div> */}

                      <div className={styles.titleContainer} style={{ marginLeft: reacd?.cover_image ? `1rem` : '0' }}>
                        <Link href={`/article/${reacd?.article_id}/${getPathTitle(reacd?.title)}`}>
                          <div className={styles.title}>{reacd?.title}</div>
                        </Link>

                        {reacd?.labels?.length > 0 && (
                          <div className={styles.tagContiner}>
                            <span className={styles.tagTitle}>{t('tags')}:</span>
                            {(reacd?.labels ?? []).map((item: string, index: number) => {
                              var color = `var(--app-link-color)`;
                              if (tagRequest && areEqualIgnoreCase(`${tag}`, `${item}`)) {
                                color = '#E1AE72';
                              }

                              const itemStr = index == reacd?.labels.length - 1 ? item : `${item},`;
                              return (
                                <Link
                                  className={styles.tagContent}
                                  style={{ color: color }}
                                  key={index}
                                  href={`/search?tag=${item}`}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                >
                                  {itemStr}{' '}
                                </Link>
                              );
                            })}
                          </div>
                        )}
                        <div className={styles.desc}>{reacd?.description}</div>
                        <div className={styles.time}>{reacd?.create_time}</div>
                      </div>
                    </div>
                  );
                },
              },
            }}
            request={async (params: any) => {
              const tempParams = tagRequest
                ? {
                  label: searchText,
                  order_column: sortText,
                  page_no: params.current,
                  page_size: params.pageSize,
                }
                : {
                  title: searchText,
                  order_column: sortText,
                  page_no: params.current,
                  page_size: params.pageSize,
                };

              const res = await getArticleListSearchData(tempParams, tagRequest, router.locale);
              setShowEmpty(res == undefined || (res?.data?.length ?? 0) == 0);

              var idList: number[] = [];

              const tempList = (res?.data ?? []).filter((item) => {
                if (!idList.includes(item.article_id)) {
                  idList.push(item.article_id);
                  return true;
                }
                return false;
              });

              return {
                ...res,
                data: tempList,
              };
            }}
          />

          <div className={styles.empty} style={{ display: showEmpty ? 'block' : 'none' }}>
            <EmptyPage />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchContent;
